<mat-form-field
  [ngClass]="{ 'disabled': disabled }"
  class="w-full px-4 example-chip-list"
  appearance="outline"
>
  <mat-label>{{ label }}</mat-label>
  <mat-chip-list [formControl]="itemCtrl" #chipList aria-label="Item selection">
    <mat-chip
      *ngFor="let item of items; let i = index"
      (removed)="remove(item)"
    >
      {{ item?.description }}
      <button matChipRemove>
        <pulse-icon [size]="15" icon="close"></pulse-icon>
      </button>
    </mat-chip>
    <input
      [placeholder]="placeholder"
      #itemInput
      [formControl]="itemCtrl"
      [matAutocomplete]="auto"
      [disabled]="disabled"
      [matChipInputFor]="chipList"
      [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
      (matChipInputTokenEnd)="add($event)"
    />
  </mat-chip-list>
  <mat-autocomplete #auto="matAutocomplete" (optionSelected)="selected($event)">
    <mat-option *ngFor="let item of filteredItems | async" [value]="item">
      <span class="text-sm">{{ item?.description }}</span>
    </mat-option>
  </mat-autocomplete>
</mat-form-field>
